module.exports = __webpack_public_path__ + "img/16m009-06.9468da22.jpg";